/**
 * @generated SignedSource<<a2baf37211ae5491c978da54b9e2dea8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainConvertToWorkspaceTemplateMutation$variables = {
  id: string;
};
export type RoutineEditMainConvertToWorkspaceTemplateMutation$data = {
  readonly routine: {
    readonly createWorkspaceTemplateFromRoutine: {
      readonly id: string;
    } | null;
  } | null;
};
export type RoutineEditMainConvertToWorkspaceTemplateMutation = {
  response: RoutineEditMainConvertToWorkspaceTemplateMutation$data;
  variables: RoutineEditMainConvertToWorkspaceTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "createWorkspaceTemplateFromRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainConvertToWorkspaceTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainConvertToWorkspaceTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f498179deeaa8b1fa286cea5f0502479",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainConvertToWorkspaceTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainConvertToWorkspaceTemplateMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    createWorkspaceTemplateFromRoutine {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24337f9e4d8cb2d347d2f5237a22bf57";

export default node;
